const firebaseConfig = {
    apiKey: "AIzaSyAZ1VgqKsi8Id4ycvBJHUbzligrNcKwYLk",
    authDomain: "creative-agency-26455.firebaseapp.com",
    databaseURL: "https://creative-agency-26455.firebaseio.com",
    projectId: "creative-agency-26455",
    storageBucket: "creative-agency-26455.appspot.com",
    messagingSenderId: "881024476804",
    appId: "1:881024476804:web:2bacb8515d61890bc704d1"
  };

  export default firebaseConfig;